<template>
  <VDialog v-model="dialog" width="500">
    <VCard>
      <VCardTitle>
        {{ $t("acts") }}
        <VSpacer />
        <VBtn fab text small @click="dialog = false">
          <VIcon size="20">mdi-close</VIcon>
        </VBtn>
      </VCardTitle>
      <VCardText>
        <VRow class="px-3">
          <VCol
            cols="6"
            :key="item.orderItemId"
            v-for="item in items"
            class="pa-0"
          >
            <VListItem class="px-0" dense>
              <VListItemContent>
                <VListItemTitle>
                  <p class="mb-1">
                    {{ $t("numberRequest") }}: {{ item.parentNumb }}
                  </p>
                  <p class="mb-1">{{ $t("position") }}: {{ item.childNumb }}</p>
                </VListItemTitle>
              </VListItemContent>
            </VListItem>
          </VCol>
        </VRow>

        <VSheet
          :key="`file-${index}`"
          v-for="(item, index) in files"
          color="primary"
          class="px-2 mb-1"
          rounded
          dark
        >
          <span>{{ item.aktFileName }}</span>
          <Downloader
            btn-class="w"
            :address="item.aktFileLink"
            :file-name="item.aktFileName"
          />
        </VSheet>
        <VBtn
          v-if="hasAccessUploadFile"
          :loading="loading"
          @click="browseFile"
          color="primary"
          width="100%"
          class="mt-2"
        >
          <VueIcon icon="newPlusIcon" />
        </VBtn>
      </VCardText>
      <input
        v-if="hasAccessUploadFile"
        @change="uploadFile"
        ref="fileInput"
        type="file"
        class="d-none"
      />
    </VCard>
  </VDialog>
</template>

<script>
import Downloader from "@/components/ui/downloader";

export default {
  name: "OmtkOrderItemActFilesDialog",
  props: {
    hasAccessUploadFile: {
      type: Boolean,
      default: false,
    },
  },
  components: { Downloader },
  data() {
    return {
      items: [],
      dialog: false,
      /**
       * @type Array<{aktFileLink:string, aktFileName:string}>
       */
      files: [],
      loading: false,
    };
  },
  methods: {
    async open(items) {
      this.items = items.map((item) => {
        const [parentNumb, childNumb, orderItemId] = item.split(":");
        return {
          parentNumb,
          childNumb,
          orderItemId,
        };
      });
      this.dialog = true;
    },
    browseFile() {
      const { fileInput } = this.$refs;
      fileInput.click();
    },
    async uploadFile(e) {
      const formData = new FormData();
      const orderItemIds = this.items.map((item) => {
        return item.orderItemId;
      });
      formData.append("orderItemIds", orderItemIds.join(","));
      formData.append("file", e.target.files[0]);
      try {
        this.loading = true;
        const {
          data: { data },
        } = await this.$http.post("contract/attach-akt-file", formData);
        this.setSuccess({ text: this.$t("successfullySaved") });
        this.files.push(data);
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.loading = false;
        this.clearFileInput();
      }
    },
    clearFileInput() {
      const { fileInput } = this.$refs;
      if (fileInput) {
        fileInput.setAttribute("type", "text");
        fileInput.setAttribute("type", "file");
      }
    },
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.items = [];
        this.files = [];
        this.loading = false;
        this.clearFileInput();
        this.$emit("CLOSE");
      }
    },
  },
};
</script>
